import { useQuery } from "@tanstack/react-query";
import { getProspectCriteria } from "@/app/actions/prospect-search/get/action";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchProspectCriteria(options: { avatarId?: number; enabled?: boolean } = {}) {
  const { avatarId, enabled = true } = options;

  return useQuery({
    queryKey: [QueryKey.PROSPECT_CRITERIA, avatarId],
    queryFn: () => getProspectCriteria(avatarId!),
    enabled: enabled && !!avatarId,
    staleTime: Infinity,
  });
}
